import React from "react";
import DetailsItem from "./DetailsItem";
import AddressItem from "./AddressItem";
import BranchItem from "./BranchItem";
const Details = (props) => {
  const { record, branchId } = props;
  return (
    <div className="details">
      <DetailsItem name="local_id_number" record={record} />
      <div className="spacer" />
      <AddressItem record={record} />
      <div className="spacer" />
      <DetailsItem
        phone={true}
        name="contact_info.mobile_number"
        record={record}
      />
      <div className="spacer" />
      <DetailsItem
        phone={true}
        name="contact_info.phone_number"
        record={record}
      />
      {record.branch !== +branchId ? (
        <BranchItem name="branch" record={record} />
      ) : null}
    </div>
  );
};

export default Details;
